exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".facets-create-alert{margin:10px 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/pages/advancedSearch/Alerts/advancedSearchAlert.less
// module id = 1647
// module chunks = 0